<template>
  <div>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="9" class="pt-0">
          <v-row>
            <v-col class="ml-0">
              <v-btn class="text-none" @click="cancel" text><v-icon small>mdi-arrow-left</v-icon>Back to deep links</v-btn>
              <h1>Create new Deep Link</h1>
            </v-col>
          </v-row>

          <v-form ref="form" v-model="valid" lazy-validation class="elevation-2 mb-10 pt-10 white">
            <v-row justify="center">
              <v-col cols="11" class="pt-0">
                <v-text-field class="pb-0 mb-0"
                              v-model="key"
                              label="Key"
                              placeholder="Please enter a name for the deep link"
                              outlined
                              :rules="[v => !!v || 'Please enter a name for the deep link']"
                              required/>

                <v-text-field class="pb-0 mb-0"
                              v-model="displayName"
                              label="Display name"
                              placeholder="Please enter a display name for the deep link"
                              outlined
                              :rules="[v => !!v || 'Please enter a display name for the deep link']"
                              required/>

                <v-textarea class="pb-0 mb-0"
                            v-model="description"
                            label="Description"
                            placeholder="Please enter a description for the deep link"
                            outlined
                            :rules="[v => !!v || 'Please enter a description for the deep link']"
                            required/>
              </v-col>
            </v-row>
          </v-form>

          <v-row>
            <v-col align="right" cols="12" class="pt-0">
              <v-btn class="text-capitalize mr-3" @click="cancel" text>Cancel</v-btn>
              <v-btn class="text-capitalize" color="primary" @click="submit" large>Save</v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'createDeeplink',
    data: () => ({
      key: null,
      displayName: null,
      description: null,
      valid: true
    }),
    methods: {
      validate() {
        this.$log.debug("validating form data");
        return this.$refs.form.validate();
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      cancel() {
        this.reset();
        this.$router.push( { name: "deeplinks" });
      },
      submit() {
        this.valid = this.$refs.form.validate();

        if (this.valid) {
          const formData = {
            key: this.key,
            display_name: this.displayName,
            description: this.description
          };

          this.$log.debug('Saving deeplink: ', formData);

          //TODO: API INTEGRATION TO POST DEEPLINK

          this.$router.push( { name: "deeplinks", params: { displayAlert: "true"}});
          //this.$router.push("/deeplinks");
        }
      }
    },
  };
</script>
